import React from 'react'
import {Button} from "react-bootstrap";
import {QUARTERLY} from "../../../constants/plans/pro-student";
import CustomTooltip from "../../CustomTooltip";

import styles from "./PlanCard.module.css";
import {PERIOD_YEAR} from "../../../constants/plans";

const getPrice = (period, price) => period === 'yearly' ? price / 12 : price

export const ToolTip = ({ children, text }) => <CustomTooltip label={text}>
    {children}
</CustomTooltip>

const PlanCard = ({ position, plan, subtitle, period, features, ctaTheme, onSubPlanClick, popular }) => {
  const price = plan.prices[period].value;
  return <div
    className={`${styles[position]} ${styles.container} flip-in-ver-left ${popular ? styles.popular : ''}`}
    onClick={() => onSubPlanClick(plan)}
  >
    {popular && <div className={styles.popularBadge}>Most popular</div>}
    <h2 className="font-26 color-purple bold mt-3">
      {plan.label}
    </h2>
    <div className={`indie-flower-font color-purple-light-2 mt-3 mb-3 ps-3 pe-3 ${styles.subtitle}`}>
      {subtitle}
    </div>
    <Button className={styles.ctaButton} variant={ctaTheme}>
      Go {plan.label}
    </Button>
    <div className={`color-purple-light-2 mb-4 ${styles.price}`}>
      {price === 0 ?
        <div>
          <b>Free</b>
        </div>
        :
        <div>
          <div className="flex justify-center"><span className="font-14 mt-2">$</span><b>{getPrice(period, price)}</b></div>
          <div className={styles.period}>/ {period === QUARTERLY ? '3-months' :  'month'}</div>
          {period === PERIOD_YEAR && <div className="font-small grey mt-2 italic"><i>(Billed ${plan.prices[PERIOD_YEAR].value} /year)</i></div>}
        </div>}
    </div>
    <div className="mt-4">
      <span className="font-24 bold dark-grey-2">
        {plan.projectLimit}
      </span>
      <div className="light-grey font-small">
        Active sites
      </div>
    </div>
    <div className="mt-4">
      <span className="font-24 bold dark-grey-2">
        {plan.fileSizeLimit} <span className="font-small">mb</span>
      </span>
      <div className="light-grey font-small">
        File uploads
      </div>
    </div>
    {features.map(({ label, tooltip, enabled}) =>
      <div className={`mt-4 pl-3 pr-3 ${enabled ? '' : styles.disabled}`}>
        <ToolTip text={tooltip}>
          <div>
            <img height="20px" width="20px" alt="check" src={`/assets/icons/${enabled ? 'tick' : 'x'}.png`} />
            <div className={`mt-2 dark-grey ${styles.label}`}>
              {label}
            </div>
          </div>
        </ToolTip>
      </div>)}
    <div className={styles.ctaButtonContainer}>
      <Button className={`mt-4 ${styles.ctaButton}`} variant={ctaTheme}>
        Go {plan.label}
      </Button>
    </div>
  </div>
}

export default PlanCard;